export default "__VITE_ASSET__DDDPvCZq__"